import { render, staticRenderFns } from "./LgFinderPageNatureza.vue?vue&type=template&id=47dbe806"
import script from "./LgFinderPageNatureza.vue?vue&type=script&lang=js"
export * from "./LgFinderPageNatureza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports